module.exports = __webpack_public_path__ + "img/tbi-cuffs.b95ef49e.png";